/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Lifetime_3Inputs */

const cs_projects_lifetime_3 = /** @type {(inputs: Projects_Lifetime_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 měsíců`)
};

const en_projects_lifetime_3 = /** @type {(inputs: Projects_Lifetime_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 months`)
};

/**
* | output |
* | --- |
* | "12 months" |
*
* @param {Projects_Lifetime_3Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_lifetime_3 = /** @type {((inputs?: Projects_Lifetime_3Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Lifetime_3Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_lifetime_3(inputs)
	return cs_projects_lifetime_3(inputs)
});